import axios from 'axios';
import getConfig from '../config';
const { REACT_APP_API_BASE_URI } = getConfig();

export default {
  request: async (options) => {
    const jwtToken = window.localStorage.getItem('portalAccess');

    // Add token to all requests if it exists, unless a custom authorization header is already provided
    if (jwtToken && !(options.headers && options.headers.authorization)) {
      options.headers = options.headers || {};
      options.headers.Authorization = `Bearer ${jwtToken}`;
    }
    options.url = `${REACT_APP_API_BASE_URI}${options.url}`;
    const response = await axios(options);
    if (response === 'Unauthorized') {
      window.location.reload();
    }
    return response;
  }
};
